export default __webpack_public_path__ + "static/media/item-2.5a372ab3.png";